export const JobInfoBox = ({ bgColor, borderColor, className, children }: {
  bgColor: string;
  borderColor: string;
  className?: string;
  children: React.ReactNode;
}) => (
  <div className="pb-4 col-span-7">
    <div className={`flex gap-3 p-4 ${bgColor} border ${borderColor} rounded ${className ?? ''}`}>
      {children}
    </div>
  </div>
);
